import React from "react";
import PropTypes from "prop-types";

import Modal from "core/Modal";
import ErrorItem from "./ErrorItem";

const ErrorModal = ({ open, handleClose, uploadErrors = [] }) => {
    return (
        <Modal
            open={open}
            handleClose={handleClose}
            heading="Error Details"
            closeOnEscape
            closeOnBackDropClick
        >
            {uploadErrors.map(({ filename, error }, idx) => (
                <ErrorItem
                    key={idx}
                    uploadName={filename}
                    errorMessage={error}
                />
            ))}
        </Modal>
    );
};

ErrorModal.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    uploadErrors: PropTypes.array.isRequired
};

export default ErrorModal;
